import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { CredentialsValue } from './pages/credentials-value/credentials-value';
import { StudentIndustryCredentials } from './pages/student-industry-credentials/student-industry-credentials';
import { IndividualizedAdvising } from './pages/individualized-advising/individualized-advising';
import { CareerClusters } from './pages/career-clusters/career-clusters';
import { CareerCoaches } from './pages/career-coaches/career-coaches';
import { Ctso } from './pages/ctso/ctso';
import { MilitaryReadiness } from './pages/military-readiness/military-readiness';
import { SeamlessTransitions } from './pages/seamless-transitions/seamless-transitions';
import { WorkBasedLearning } from './pages/work-based-learning/work-based-learning';
import { AccountabilityDataReporting } from './pages/accountability-data-reporting/accountability-data-reporting';
import { ComputerScience } from './pages/computer-science/computer-science';
import { Epso } from './pages/epso/epso';
import { EpsoFeeAssistance } from './pages/epso-fee-assistance/epso-fee-assistance';
import { InnovativeSchoolStrategies } from './pages/innovative-school-strategies/innovative-school-strategies';
import { LicensureAndTrainingAttendanceRec } from './pages/licensure-and-training-attendance-rec/licensure-and-training-attendance-rec';
import { Stem } from './pages/stem/stem';
import { AdvancedManufacturing } from './pages/advanced-manufacturing/advanced-manufacturing';
import { Agriculture } from './pages/agriculture/agriculture';
import { CivicsPublicServiceAndSafety } from './pages/civics-public-service-and-safety/civics-public-service-and-safety';
import { Construction } from './pages/construction/construction';
import { D } from '@angular/cdk/keycodes';
import { DigitalTechnology } from './pages/digital-technology/digital-technology';
import { Education } from './pages/education/education';
import { FinancialServices } from './pages/financial-services/financial-services';
import { HealthcareAndHumanServices } from './pages/healthcare-and-human-services/healthcare-and-human-services';
import { HospitalityAndEvents } from './pages/hospitality-and-events/hospitality-and-events';
import { MarketingAndSales } from './pages/marketing-and-sales/marketing-and-sales';
import { MiddleSchoolCteCourses } from './pages/middle-school-cte-courses/middle-school-cte-courses';
import { CteEducatorResources } from './pages/cte-educator-resources/cte-educator-resources';
import { ManagementAndEntreprenuership } from './pages/management-and-entreprenuership/management-and-entreprenuership';
import { ArtsEntertainDesign } from './pages/arts-entertain-design/arts-entertain-design';
import { GraduationRequirements } from './pages/graduation-requirements/graduation-requirements';
import { EnergySustainableResources } from './pages/energy-sustainable-resources/energy-sustainable-resources';
import { SupplyChainAndTransportation } from './pages/supply-chain-and-transportation/supply-chain-and-transportation';

export const routes: Routes = [
    {   path: '', pathMatch: 'full', redirectTo: '/home' },
    {   path: 'home',   component: Home },
    {   path: 'pillar-1',  component: CredentialsValue },
    {   path: 'pillar-1/student-industry-credentials',  component: StudentIndustryCredentials },
    {   path: 'pillar-2',  component: SeamlessTransitions },
    {   path: 'pillar-2/accountability-data-reporting', component: AccountabilityDataReporting },
    {   path: 'pillar-2/computer-science',  component: ComputerScience  },
    {   path: 'pillar-2/epso',  component: Epso },
    {   path: 'pillar-2/epso-fee-assistance',  component: EpsoFeeAssistance },
    {   path: 'pillar-2/innovative-school-strategies',  component: InnovativeSchoolStrategies },
    {   path: 'pillar-2/licensure-and-training-attendance-rec',  component: LicensureAndTrainingAttendanceRec },
    {   path: 'pillar-2/stem',  component: Stem },
    {   path: 'pillar-3',  component: IndividualizedAdvising },
    {   path: 'pillar-3/career-clusters',  component: CareerClusters },
    {   path: 'pillar-3/career-clusters/advanced-manufacturing',  component: AdvancedManufacturing },
    {   path: 'pillar-3/career-clusters/agriculture',  component: Agriculture },
    {   path: 'pillar-3/career-clusters/arts-entertain-design',  component: ArtsEntertainDesign  },
    {   path: 'pillar-3/career-clusters/civics-public-service-and-safety',  component: CivicsPublicServiceAndSafety },
    {   path: 'pillar-3/career-clusters/construction',  component: Construction  },
    {   path: 'pillar-3/career-clusters/cte-educator-resources',  component: CteEducatorResources },
    {   path: 'pillar-3/career-clusters/digital-technology',  component: DigitalTechnology },
    {   path: 'pillar-3/career-clusters/education',  component: Education },
    {   path: 'pillar-3/career-clusters/energy-sustainable-res',  component: EnergySustainableResources },
    {   path: 'pillar-3/career-clusters/financial-services',  component: FinancialServices },
    {   path: 'pillar-3/career-clusters/healthcare-and-human-services',  component: HealthcareAndHumanServices },
    {   path: 'pillar-3/career-clusters/hospitality-and-events',  component: HospitalityAndEvents },
    {   path: 'pillar-3/career-clusters/management-and-entrepreneurship',  component: ManagementAndEntreprenuership },
    {   path: 'pillar-3/career-clusters/marketing-and-sales',  component: MarketingAndSales },    
    {   path: 'pillar-3/career-clusters/middle-school-cte-courses',  component:  MiddleSchoolCteCourses },
    {   path: 'pillar-3/career-clusters/supply-chain-and-transportation',  component: SupplyChainAndTransportation },
    {   path: 'pillar-3/career-coaches',  component: CareerCoaches },
    {   path: 'pillar-3/ctso',  component: Ctso },
    {   path: 'pillar-3/graduation-requirements',  component: GraduationRequirements },    
    {   path: 'pillar-3/military-readiness',  component: MilitaryReadiness },
    {   path: 'pillar-4',  component: WorkBasedLearning },

];
